<template>
    <div class="wrapper flex flex-column justify-content-center align-items-center p-4  w-full">
        <CustomBreadcrumb class="flex align-self-start" :items="[{ label: 'Profile Settings' }, { label: 'Photo' }]" />
        <span class="block text-center H6-Medium mt-6">
            Ride the ILearn’d wave
        </span>
        <span class="block text-center Label mt-2">
            Complete your profile with a pic
        </span>
        <div class="card flex justify-center justify-content-center">
            <div class="user-image">
                <Image :src="imageSource" alt="Image" width="250" />
            </div>
        </div>
        <div class="card flex flex-wrap gap-6 items-center justify-between justify-content-center mt-8"
            v-if="!imageSource.includes('https')">
            <FileUpload ref="fileupload" mode="basic" name="demo[]" url="/api/upload" accept="image/*"
                :maxFileSize="1000000" class="yellow-button" />
            <Button label="Enable" @click="onUpload"  class="yellow-button"
                :loading="apiCallInProgress" />
        </div>
        <div class="card flex flex-wrap gap-6 items-center justify-between justify-content-center mt-8" v-else>
            <Button label="Remove Profile Image" @click="onRemove"  class="yellow-button" />
        </div>
    </div>
</template>

<script setup>
import CustomBreadcrumb from '@/components/CustomBreadcrumb.vue';
import { Button, FileUpload, Image } from 'primevue';
import logo from '@/assets/blank-profile.png';
import { ref, defineProps, defineEmits, watchEffect } from 'vue';
import { useAuthStore } from '@/stores/authStore';
import { notifyError, notifyWarn } from '@/utils/notification';
import { generateSignedUrl, uploadProfileImage } from '@/api/storage';

const props = defineProps({
    profile: {
        type: Object,
        required: true
    }
});

const emit = defineEmits(["update-prfile"]);
const authStore = useAuthStore();
const fileupload = ref();
const profileUrl = ref(null);
const imageSource = ref(logo);
const apiCallInProgress = ref(false);

const fetchUserProfile = async () => {
    profileUrl.value = props.profile.profilePhotoURL;
};

const onUpload = async () => {
    if (!fileupload.value.files || fileupload.value.files.length === 0) {
        notifyWarn("", "Please select a file to upload.");
        return;
    }

    try {
        apiCallInProgress.value = true;
        const file = fileupload.value.files[0];
        const formData = new FormData();
        formData.append('file', file);

        const res = await uploadProfileImage(formData);
        profileUrl.value = res.data.url;

        const payload = {
            profilePhotoURL: profileUrl.value
        }

        emit("update-profile", payload);
        authStore.user.profilePhotoURL = profileUrl.value;
        await authStore.loadProfileImage();
    } catch (error) {
        console.error('Upload failed:', error);
        notifyError("Error", "File upload failed. Please try again.");
    } finally {
        apiCallInProgress.value = false;
        fileupload.value.clear();
    }
};

const onRemove = () => {
    const payload = {
        profilePhotoURL: null
    }
    authStore.profileImageUrl = '';
    authStore.imageCache = null;
    profileUrl.value = null;
    emit("update-profile", payload);
}
watchEffect(() => {
    fetchUserProfile();
});

watchEffect(async () => {
    imageSource.value = profileUrl.value && profileUrl.value !== 'Service is not available in local environment' ?
        await generateSignedUrl(profileUrl.value) : logo;
});
</script>

<style scoped>
/* .wrapper {
    height: 95%;
    background-color: white;
    border-radius: 10px;
    box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px,
        rgba(60, 64, 67, 0.15) 0px 1px 3px 1px;
} */

.user-image {
    margin-top: 5vh;
    padding: 10px;
    border-radius: 10px;
    box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
}
</style>
